import React from 'react';

import { makeStyles } from '@mui/styles';
import RemoveIcon from '@mui/icons-material/Clear';
import Tooltip from '@mui/material/Tooltip';
import ZoomOutMapOutlinedIcon from '@mui/icons-material/ZoomOutMapOutlined';

import { getNodeAvatar } from '../utils';
import { connect } from 'react-redux';

const useStyles = makeStyles({
  tooltip: {
    margin: '7px',
    background: '#222029',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    borderRadius: 0,
    opacity: 0.8,
    padding: '10px 15px',
  },
  /* Styles applied to the arrow element. */
  arrow: {
    color: '#222029',
    opacity: 0.8,
  },
  tooltipMainText: {
    marginBottom: '5px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    fontFeatureSettings: '\'pnum\' on, \'lnum\' on'
  },
  tooltipExtraText: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '16px',
    fontFeatureSettings: '\'pnum\' on, \'lnum\' on',
    color: '#C4C4C4',
  },
  node: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    alignSelf: 'flex-start',
  },
  nodeBox: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff !important',
    width: '100%',
  },
  nodeHashtagLink: {
    color: '#fff !important',
  },
  entity: {
    textDecoration: 'none',
    borderSpacing: '0px',
    borderCollapse: 'separate',
    height: '38px',
    whiteSpace: 'normal',
    lineHeight: 'normal',
  },
  flatNodeMin: {
    textDecoration: 'none',
    color: 'white',
    borderSpacing: '0px',
    borderCollapse: 'separate',
    height: '38px',
    whiteSpace: 'normal',
    lineHeight: 'normal',
  },
  removeIcon: {
    fontSize: '18px',
    alignSelf: 'flex-start',
    color: '#fff',
    '&:hover': {
      color: 'red',
      cursor: 'pointer',
    },
  },
  removeIconXs: {
    fontSize: '13px',
    alignSelf: 'center',
  },
  removeIconSm: {
    fontSize: '16px',
    alignSelf: 'center',
  },
  xs: {
    height: '21px',
    fontSize: '11px',
    whiteSpace: 'nowrap',
  },
  sm: {
    height: '24px',
    fontSize: 12,
  },
  hashtagBox: {
    opacity: '0.8',
    '&:hover': {
      opacity: '1',
      transition: '0.1s',
    },
  },
  hashtagBoxXs: {
    height: '21px',
    padding: '0 3px',
    display: 'flex',
    alignItems: 'center',
  },
  hashtagBoxSm: {
    height: '24px',
    padding: '0 3px',
    display: 'flex',
    alignItems: 'center',
  },
  hashtagBoxMd: {
    height: '38px',
    lineHeight: '38px',
    display: 'flex',
    alignItems: 'center',
  },
  nodeHashtag: {
    width: '32px',
    padding: '2px 1px 2px 3px',
    textAlign: 'center',
    fontSize: '20px',
  },
  hashtagXs: {
    fontSize: 12,
    width: 'auto',
  },
  hashtagSm: {
    fontSize: 14,
    width: 'auto',
  },
  hashtagMd: {
    width: 'auto',
    padding: '0 10px',
  },
  lg: {
    transition: '0.1s',
    display: 'block',
    padding: '0px',
    textAlign: 'left',
    fontSize: '20px',
    color: 'white',
    width: '250px',
    marginBottom: '20px',
    boxShadow: '1px 2px 4px #D6D6D6',
  },
  nodeImg: {
    margin: '2px',
    width: '30px',
    height: '30px',
    borderRadius: '100%',
  },
  nodeImgXs: {
    width: '14px',
    height: '14px',
  },
  nodeImgSm: {
    width: '16px',
    height: '16px',
  },
  nodeImgLg: {
    padding: '20px',
    flexShrink: '0',
    width: '50px',
    height: '50px',
  },
  nodeTitleContainer: {
    overflow: 'hidden',
  },
  nodeTitleXs: {
    color: '#FDFDFD',
    fontSize: 12,
    maxWidth: '120px',
    overflow: 'hidden',
    paddingRight: '2px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingLeft: '2px',
  },
  nodeTitleSm: {
    color: '#FDFDFD',
    fontSize: 12,
    maxWidth: '120px',
    overflow: 'hidden',
    paddingRight: '4px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    padding: '0 0 0 5px',
  },
  nodeTitleMd: {
    color: '#FDFDFD',
    fontSize: '15px',
    maxWidth: '140px',
    overflow: 'hidden',
    lineHeight: '20px',
    paddingLeft: '5px',
    paddingRight: '5px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  concepts: {
    marginTop: '-3px',
    overflow: 'hidden',
    paddingRight: '5px',
    whiteSpace: 'nowrap',
    lineHeight: '12.5px',
    textOverflow: 'ellipsis',
  },
  concept: {
    color: '#fff',
    opacity: '0.7',
    fontSize: '10px',
    fontWeight: '400',
    marginRight: '5px',
  },
  bigNodeLeftCol: {
    padding: '40px 20px',
    fontSize: '35px',
    flexShrink: '0',
  },
  bigNodeRightCol: {
    padding: '40px 20px 40px 10px',
  },
  striped: {
    backgroundImage:
      'linear-gradient(135deg, transparent 25%, rgba(255, 255, 255, 0.2) 25%, rgba(255, 255, 255, 0.2) 50%, transparent 50%, transparent 75%, rgba(255, 255, 255, 0.2) 75%, rgba(255, 255, 255, 0.2) 100%)',
    backgroundSize: '31.43px 31.43px',
  },
  nodeBg: (props) => {
    if (!props.backgroundColor) return {backgroundColor: `transparent`}
    return {
      backgroundColor: `#${props.backgroundColor}`,
    };
  },
  titleColorIfEditForm: {
    color: '#4c4c4c',
    '&:hover': {
      '& .btn-icon': {
        color: '#fff',
      },
    }
  },
  nodeWithOpenForm: {
    height: '21px',
    fontSize: 11,
    opacity: '0.9',
    borderRadius: '20px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    width: 'fit-content',
    backgroundColor: '#322D3B',
    '&:hover': {
      opacity: '1',
      background: '#222029',
      boxShadow: 'none',
    },
  },
});

export default connect((state) => ({ account: state.meta.account }))(({
  nodes,
  node,
  size,
  nodeId,
  isLink,
  onClick,
  account,
  formEdit,
  className,
  style = {},
  isRemovable,
  customTitle,
  showConcepts,
  isTransparent,
  onRemoveClick,
  titleStyle = {},
}) => {
  if (!node) {
    node = {
      id: nodeId,
      deleted: true,
      color: (isTransparent || formEdit) ? '4c4c4c' : 'dbdbdb',
      title: '',
    };
  }

  const accountOntologyId = account && account.individual && account.individual.ontology;
  const nodeOntologyId = node && node.ontology;

  const nodeLinkAttrs = {};
  const classes = useStyles({
    backgroundColor: (isTransparent || (formEdit && customTitle)) ? '#e8ebf5' : node.color,
  });

  const isNodeHashtagLink = isLink && account.access_level > 1;
  if (isNodeHashtagLink) nodeLinkAttrs.href = `/node/${node.id}`;

  const nodeClassName =
    size === 'xs'
      ? `${classes.entity} ${classes.xs}`
      : size === 'sm'
      ? `${classes.entity} ${classes.sm}`
      : size === 'big'
      ? classes.lg
      : `${classes.entity} ${classes.flatNodeMin}`;

  const isSmall = size === 'small' ? '0.7' : '1';

  let extraText = false;

  if (!!nodes && !!nodes[nodeId]) {
    const bottomAncestors = nodes[nodeId].box.a_bottom || [];
    const superConcepts = nodes[nodeId].box.t_supers || [];

    const hasConcepts = !!superConcepts && superConcepts.length > 0;
    const extraTextEntities = hasConcepts ? superConcepts : bottomAncestors

    const ancestorsSymbol = '*';
    const conceptsSymbol = '@';
    const entitySymbol = hasConcepts ? conceptsSymbol : ancestorsSymbol

    extraText = extraTextEntities.map(entityNodeId => {
      const entityTitle = !!nodes[entityNodeId] && nodes[entityNodeId].title;

      return !!entityTitle &&
        <li key={entityNodeId}>
          <a className={classes.tooltipExtraText} target="_blank" rel="noreferrer" href={`/node/${entityNodeId}`}>
            {entitySymbol}<u>{entityTitle}</u>
          </a>
        </li>;
    })
  }

  const nodeComponent =
    <div
      id={node.id}
      style={{
        ...style,
        zoom: `${isSmall}`,
        fontFamily: '"Urbanist", sans-serif !important',
        outline: isTransparent ? '1px dashed #FFFF' : '',
      }}
      className={`${classes.node} ${formEdit ? classes.nodeWithOpenForm : ''} ${className || ''} ${nodeClassName}`
        + ` ${classes.nodeBg} ${(!node.is_individ && !isTransparent) ? classes.striped : ''}`
      }
    >
      <div className={`${classes.nodeBox}`}>
        {node.pic ? (
          <a {...nodeLinkAttrs} className={`${classes.nodeHashtagLink}`}>
            <img
              src={size === 'sm'
                ? (getNodeAvatar(node, '32'))
                : size === 'md'
                  ? (getNodeAvatar(node, '32'))
                  : size === 'big'
                    ? (getNodeAvatar(node, '50'))
                    : null}
              alt="node-avatar"
              className={`${classes.nodeImg} ${size === 'xs'
                ? classes.nodeImgXs
                : size === 'sm'
                  ? classes.nodeImgSm
                  : size === 'big'
                    ? classes.nodeImgLg
                    : ''
              }`}
            />
          </a>
        ) : isNodeHashtagLink && (
          <a {...nodeLinkAttrs} className={`${classes.nodeHashtagLink}`}>
            <div
              className={`${isNodeHashtagLink ? classes.hashtagBox : ''}
              ${size === 'xs'
                ? classes.hashtagBoxXs
                : size === 'sm'
                  ? classes.hashtagBoxSm
                  : size === 'md'
                    ? classes.hashtagBoxMd
                    : ''}`}
            >
              <div
                className={`${isNodeHashtagLink ? classes.nodeHashtag : ''} 
                ${size === 'xs'
                  ? classes.hashtagXs
                  : size === 'sm'
                    ? classes.hashtagSm
                    : size === 'md'
                      ? classes.hashtagMd
                      : size === 'big'
                        ? classes.bigNodeLeftCol
                        : ''
                }`}
              >
                #
              </div>
            </div>
          </a>
        )}

        <div
          className={classes.nodeTitleContainer}
          onClick={onClick}
        >
          <div
            style={{
              ...titleStyle,
              paddingLeft: `${size === 'xs' && formEdit && !isNodeHashtagLink ? '10px' : ''}`
            }}
            className={`${size === 'xs'
              ? classes.nodeTitleXs
              : size === 'sm'
                ? classes.nodeTitleSm
                : size === 'md'
                  ? classes.nodeTitleMd
                  : size === 'big'
                    ? classes.bigNodeRightCol
                    : ''
            } title-l`}
          >
            {node.deleted ? `[${nodeId}]` : ''} {customTitle ? customTitle : node.title}
          </div>

          {showConcepts && node.concepts && size === 'md' ? (
            <div className={classes.concepts}>
              {node.concepts.map((concept) => {
                return (
                  <span key={concept.id} className={classes.concept}>
                    *{concept.title}
                  </span>
                );
              })}
            </div>
          ) : null}
        </div>
        {(size !== 'xs' && accountOntologyId && nodeOntologyId && (accountOntologyId !== nodeOntologyId)) ?
          <div alt='ontology' style={{ position: 'absolute', bottom: 0, right: '2px', fontSize: size === 'sm' ? 8 : 10 }}>{nodeOntologyId}</div>
        : null}
      </div>

      {isRemovable && (
        <RemoveIcon
          className={`${classes.removeIcon} ${size === 'xs'
            ? classes.removeIconXs
            : size === 'sm'
              ? classes.removeIconSm
              : ''
            }`}
          onClick={onRemoveClick}
        />
      )}

      {formEdit ?
        <ZoomOutMapOutlinedIcon
          onClick={onClick}
          className={'btn-icon'}
          style={{
            fontSize: '13px',
            marginRight: '5px',
            marginLeft: '2px',
            color: '#fff',
          }}
        />
      : null}
    </div>

    const getTooltipMainText = account.access_level > 1
      ? <span>
        <a style={{ color: 'white' }}>{node.id}</a> | {' '}
        <a style={{ color: 'white', textDecoration: 'underline' }}
           target="_blank"
           rel="noreferrer"
           href={`/node/${node.id}`}>
          {node.title}
        </a>
        </span>
      : <span>{node.id} | {node.title}</span>;

  return (
    <React.Fragment>
      {nodes && !formEdit ? (
        <Tooltip
          title={
            <React.Fragment>
              <div className={classes.tooltipMainText}>{getTooltipMainText}</div>
              {nodeOntologyId ? <div className={classes.tooltipMainText}>ontology: {nodeOntologyId}</div> : null}
              <ul className={classes.tooltipExtraText}>
                {extraText}
              </ul>
            </React.Fragment>

          }
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.arrow,
          }}
          arrow
          enterDelay={1000}
          enterNextDelay={1000}
          interactive="true"
        >
          {nodeComponent}
        </Tooltip>
      ) : nodeComponent}
    </React.Fragment>
  );
});
